import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Contact.css";

const initialForm = {
    name: "",
    email: "",
    subject: "",
    message: "",
};

const Contact = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(initialForm);
    const [status, setStatus] = useState({ type: "", message: "" });
    const [submitting, setSubmitting] = useState(false);

    const handleChange = ({ target: { name, value } }) =>
        setFormData((prev) => ({ ...prev, [name]: value }));

    const handleSubmit = async (event) => {
    event.preventDefault();

    setStatus({ type: "", message: "" });
    setSubmitting(true);

    try {
        const response = await fetch("/api/contact", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(formData),
        });

        const text = await response.text();

        console.log(
            "CONTACT RESPONSE:",
            response.status,
            text
        );

        let data;

        try {
            data = JSON.parse(text);
        } catch {
            throw new Error(
                `Server returned ${response.status}: ${text.substring(0, 300)}`
            );
        }

        if (!response.ok) {
            throw new Error(
                data.message ||
                "Unable to send your message."
            );
        }

        setStatus({
            type: "success",
            message:
                data.message ||
                "Thank you! Your message has been sent successfully.",
        });

        setFormData(initialForm);

    } catch (error) {
        console.error(
            "Contact form error:",
            error
        );

        setStatus({
            type: "error",
            message:
                error.message ||
                "Something went wrong. Please try again.",
        });

    } finally {
        setSubmitting(false);
    }
};
    return (
        <div className="contact-page">

            <header className="contact-header">
                <button
                    className="contact-back-button"
                    onClick={() => navigate("/dashboard")}
                >
                    ← Dashboard
                </button>

                <div className="contact-header-content">
                    <div className="contact-eyebrow">STEMX365</div>
                    <h1>Contact Us</h1>
                    <p>
                        Have a question about our space robotics
                        laboratories, courses, or platform? We would
                        love to hear from you.
                    </p>
                </div>
            </header>

            <main className="contact-container">

                {/* Contact Information */}
                <section className="contact-info">
                    <div className="contact-section-label">
                        GET IN TOUCH
                    </div>

                    <h2>
                        Let's build the future of space robotics.
                    </h2>

                    <p className="contact-intro">
                        STEMX365 provides students with access to
                        programming and simulation environments for
                        real space robotics platforms. If you have
                        questions, need technical assistance, or would
                        like to learn more about our programs, send us
                        a message.
                    </p>

                 

                    <div className="contact-info-item">
                        <div className="contact-info-icon">🛠</div>
                        <div>
                            <span>Technical Support</span>
                            <p>
                                Need help with a lab, simulation, or
                                IDE? Tell us what you're experiencing.
                            </p>
                        </div>
                    </div>

                    <div className="contact-info-item">
                        <div className="contact-info-icon">🚀</div>
                        <div>
                            <span>Educational Programs</span>
                            <p>
                                Schools, educators, and organizations
                                interested in STEMX365 programs are
                                welcome to contact us.
                            </p>
                        </div>
                    </div>

                    <div className="contact-response">
                        <div className="contact-response-icon">✓</div>
                        <div>
                            <strong>We will get back to you.</strong>
                            <p>
                                Our team typically responds within
                                1–2 business days.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Contact Form */}
                <section className="contact-form-card">

                    <div className="form-card-header">
                        <div className="form-card-label">
                            SEND A MESSAGE
                        </div>
                        <h2>How can we help?</h2>
                    </div>

                    {status.message && (
                        <div className={`contact-status ${status.type}`}>
                            {status.message}
                        </div>
                    )}

                    <form
                        className="contact-form"
                        onSubmit={handleSubmit}
                    >

                        <div className="form-field">
                            <label htmlFor="contact-name">Name</label>
                            <input
                                id="contact-name"
                                name="name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your name"
                                required
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="contact-email">Email</label>
                            <input
                                id="contact-email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="you@example.com"
                                required
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="contact-subject">
                                Subject
                            </label>

                            <select
                                id="contact-subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            >
                                <option value="">
                                    Select a subject
                                </option>
                                <option value="technical-support">
                                    Technical Support
                                </option>
                                <option value="lab-access">
                                    Lab Access
                                </option>
                                <option value="subscription">
                                    Subscription
                                </option>
                                <option value="education">
                                    Education / Schools
                                </option>
                                <option value="partnership">
                                    Partnership
                                </option>
                                <option value="general">
                                    General Question
                                </option>
                            </select>
                        </div>

                        <div className="form-field">
                            <label htmlFor="contact-message">
                                Message
                            </label>

                            <textarea
                                id="contact-message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Tell us how we can help..."
                                rows={7}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="contact-submit-button"
                            disabled={submitting}
                        >
                            {submitting
                                ? "Sending..."
                                : "Send Message →"}
                        </button>

                        <p className="form-privacy">
                            Your information will only be used to
                            respond to your message.
                        </p>

                    </form>
                </section>
            </main>

            <footer className="contact-footer">
                <div>
                    © {new Date().getFullYear()} STEMX365
                </div>

                <div className="contact-footer-links">
                    <button onClick={() => navigate("/rect/dash")}>
                        Dashboard
                    </button>
                    <button onClick={() => navigate("/rect/labs")}>
                        Labs
                    </button>
                    {/* <button onClick={() => navigate("/support")}>
                        Support
                    </button> */}
                </div>
            </footer>

        </div>
    );
};

export default Contact;